export default "__VITE_ASSET__BJU_szSr__"